/* WhatsApp "DM for Price" buttons: keep the message in sync with the selected
   variant. Rebuilds each .wa-dm-btn href with the product title, the selected
   variant title (when available) and the absolute product URL. Falls back
   safely when no variant data can be resolved. */
(function () {
  var SCOPES =
    '.sticky-pro-inner, .quickview_popup_data, .product-main-section, .wishlist-product, .compare-product, .product-card-inner, .product-card, .grid__item, .swiper-slide';

  function closestScope(el) {
    return (el.closest && el.closest(SCOPES)) || document;
  }

  function findVariantTitle(el) {
    if (el.getAttribute('data-wa-has-variant') !== 'true') return '';

    var scope = closestScope(el);

    /* Sticky bar uses a custom option label. */
    var selectedOpt = scope.querySelector ? scope.querySelector('.selectedOpt') : null;
    if (selectedOpt && selectedOpt.textContent && selectedOpt.textContent.trim() !== '') {
      return selectedOpt.textContent.trim();
    }

    var idInput = null;
    var explicit = el.getAttribute('data-wa-variant-input');
    if (explicit) {
      idInput = document.querySelector(explicit);
    }
    if (!idInput && scope.querySelector) {
      idInput = scope.querySelector('input[name="id"]');
    }
    if (!idInput || !idInput.value) {
      return el.getAttribute('data-wa-variant') || '';
    }
    var id = String(idInput.value);

    /* Quick-view exposes variants as hidden .variant-qv inputs. */
    var vq = scope.querySelectorAll ? scope.querySelectorAll('.variant-qv') : [];
    for (var i = 0; i < vq.length; i++) {
      if (String(vq[i].getAttribute('data-id')) === id) {
        return vq[i].getAttribute('data-title') || '';
      }
    }

    /* Product / card variants are exposed as a JSON script tag. */
    var scripts = scope.querySelectorAll ? scope.querySelectorAll('script[type="application/json"]') : [];
    for (var s = 0; s < scripts.length; s++) {
      var txt = scripts[s].textContent;
      if (!txt || txt.indexOf('"id"') === -1) continue;
      try {
        var data = JSON.parse(txt);
        if (Object.prototype.toString.call(data) === '[object Array]') {
          for (var j = 0; j < data.length; j++) {
            if (String(data[j].id) === id) return data[j].title || '';
          }
        }
      } catch (e) {
        /* ignore malformed JSON */
      }
    }

    return el.getAttribute('data-wa-variant') || '';
  }

  function buildMessage(el, variantTitle) {
    var intro = el.getAttribute('data-wa-intro') || '';
    var title = el.getAttribute('data-wa-title') || '';
    var url = el.getAttribute('data-wa-url') || '';
    var hasVariant = el.getAttribute('data-wa-has-variant') === 'true';

    var msg = intro + '\n\nProduct: ' + title;
    if (hasVariant && variantTitle) msg += '\nVariant: ' + variantTitle;
    msg += '\nProduct URL: ' + url;
    return msg;
  }

  function update(el) {
    if (!el || !el.getAttribute) return;
    var number = el.getAttribute('data-wa-number');
    if (!number) return;
    try {
      var variantTitle = findVariantTitle(el);
      var href =
        'https://wa.me/' +
        number +
        '?text=' +
        encodeURIComponent(buildMessage(el, variantTitle));
      el.setAttribute('href', href);
    } catch (e) {
      /* keep the server-rendered href on failure */
    }
  }

  function updateAll(root) {
    var container = root && root.querySelectorAll ? root : document;
    var buttons = container.querySelectorAll('.wa-dm-btn');
    for (var i = 0; i < buttons.length; i++) update(buttons[i]);
  }

  document.addEventListener(
    'change',
    function (e) {
      var t = e.target;
      if (t && t.closest && t.closest('variant-selects, variant-radios, .size-selectors')) {
        setTimeout(function () {
          updateAll(document);
        }, 60);
      }
    },
    true
  );

  document.addEventListener('shopify:section:load', function (e) {
    updateAll(e.target);
  });
  document.addEventListener('shopify:block:select', function (e) {
    updateAll(e.target);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      updateAll(document);
    });
  } else {
    updateAll(document);
  }

  window.updateWhatsAppButtons = updateAll;
})();
